export enum DimensionUnits {
    MM = 'mm',
    INCHES = 'in',
    METERS = 'm',
    CM = 'cm',
    FEET = 'ft',
  }
